import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSidemenuOverview = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(0 0) scale(1.5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M4.66547 11.8008H10.5302M6.87772 1.36446L1.90566 5.23162C1.57329 5.49012 1.40711 5.61937 1.28739 5.78124C1.18134 5.92463 1.10234 6.08616 1.05427 6.2579C1 6.45178 1 6.6623 1 7.08336V12.3872C1 13.2084 1 13.619 1.1598 13.9326C1.30037 14.2085 1.52467 14.4328 1.80055 14.5733C2.11419 14.7331 2.52476 14.7331 3.3459 14.7331H11.8498C12.6709 14.7331 13.0815 14.7331 13.3951 14.5733C13.671 14.4328 13.8953 14.2085 14.0359 13.9326C14.1957 13.619 14.1957 13.2084 14.1957 12.3872V7.08336C14.1957 6.6623 14.1957 6.45178 14.1414 6.2579C14.0933 6.08616 14.0143 5.92463 13.9083 5.78124C13.7886 5.61937 13.6224 5.49012 13.29 5.23162L8.31796 1.36446C8.06041 1.16414 7.93163 1.06398 7.78943 1.02548C7.66396 0.991507 7.53172 0.991507 7.40625 1.02548C7.26405 1.06398 7.13527 1.16414 6.87772 1.36446Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})]
});
const ForwardRef = forwardRef(SvgSidemenuOverview);
export default ForwardRef;
